<template>
  <div v-if="all_platforms">
    <PageHeaderEnv />
    <div :lang="$i18n.locale" class="h-screen flex flex-col bg-background" :class="{ 'lg:pr-16': !isProduction }">
      <slot v-if="brandconfig.BRAND === 'priority'" name="backheader">
        <BackHeader />
      </slot>
      <div class="shadow bg-header boundary border-b-8 border-primary">
        <slot name="header">
          <Xs2TicketPageHeader />
        </slot>
      </div>
      <div class="flex flex-col h-full justify-between overflow-x-hidden lg:overflow-auto content">
        <PageContent>
          <BreadCrumbs v-if="path" :path="path" />
          <slot></slot>
        </PageContent>
        <slot name="extra-content"></slot>
        <slot name="footer">
          <PageFooterBranded />
        </slot>
      </div>
    </div>
  </div>
  <div
    v-else
    class="flex flex-col bg-background bg-white w-full h-full absolute flex justify-center items-center left-0 top-0"></div>
</template>

<script setup>
import brandconfig from "@/brandconfig";

import { isProduction } from "@/config";
import PageHeaderEnv from "./PageHeaderEnv.vue";
import BreadCrumbs from "./BreadCrumbs.vue";
import Xs2TicketPageHeader from "./Xs2TicketPageHeader.vue";
import PageContent from "./PageContent.vue";
import PageFooterBranded from "./PageFooterBranded.vue";
import BackHeader from "./BackHeader.vue";
import {} from "@heroicons/vue/24/outline";
import { ref } from "vue";

defineProps({
  path: { default: null },
  title: { default: null },
});

const all_platforms = ref(true);
const deviceType = ref("");
const userAgent = ref("");
const platform = navigator.userAgent.toLowerCase();

const icon = brandconfig.BRAND_ICON;
if (icon) {
  document.querySelector("link[rel=icon]").href = icon;
}
if (/(samsung|android|webos|iphone|blackberry|linux armv81|windows phone)/.test(platform)) {
  deviceType.value = "mobile";
} else if (/mac|win|linux/i.test(platform)) {
  deviceType.value = "desktop";
} else if (/tablet|ipad/i.test(platform)) {
  deviceType.value = "tablet";
} else {
  deviceType.value = "unknown";
}
userAgent.value = navigator.userAgent;
if (brandconfig.MOBILE_ONLY === true) {
  if (deviceType.value !== "mobile" && deviceType.value !== "tablet" && deviceType.value !== "unknown") {
    all_platforms.value = false;
  }
}
</script>
<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 250ms ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
